<template>

  <v-select
      prepend-icon="category"
      :items="items"
      v-model="item"
      :label="$t('cobrox.convenio.labels.estado')"
      :loading="loading"
      :error="hasInputErrors('estado')"
      :error-messages="getInputErrors('estado')"
      color="secondary"
      item-color="secondary"
      :rules="isRequired?required:[]"
      :disabled="disabled"
      :readonly="readonly"
      :multiple="multiple"
  ></v-select>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


export default {
  name: "EstadoConvenioCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Array]},
    isRequired: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    multiple: {type: Boolean, default: false},
  },
  data() {
    return {
      items: ['VIGENTE', 'POR VENCER', 'CAIDO',  'CANCELADO'],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style scoped>

</style>

